export default "__VITE_ASSET__155aba19__"